exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disable-scroll[data-v-c102a778]{overflow:hidden!important}.searchBuddyBox[data-v-c102a778]{margin:7px 12px 10px!important}.mobileSearchTagsChild[data-v-c102a778]{width:100%!important}", ""]);

// exports
